import styled from 'styled-components';

export const DetailContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #F5F0EB;
  display: flex;
  flex-direction: column;
  padding-bottom: env(safe-area-inset-bottom);
  z-index: ${({ theme }) => theme.zIndex.modal};
  overflow-y: auto;
`;

export const CloseButtonArea = styled.div`
  padding: ${({ theme }) => theme.spacing.md};
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
  background: transparent;
  border: none;
  font-size: ${({ theme }) => theme.typography.fontSize.lg};
  color: #C4956A;
  min-height: 44px;
  min-width: 44px;
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm};
  cursor: pointer;
  border-radius: ${({ theme }) => theme.borderRadius.md};

  &:active {
    background-color: rgba(196, 149, 106, 0.1);
  }
`;

export const ContentArea = styled.div`
  flex: 1;
  padding: ${({ theme }) => theme.spacing.lg} ${({ theme }) => theme.spacing.xl};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const SeasonEmoji = styled.span`
  font-size: 48px;
  margin-bottom: ${({ theme }) => theme.spacing.md};
  line-height: 1;
`;

export const DetailTitle = styled.h2`
  font-size: ${({ theme }) => theme.typography.fontSize.xxl};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  color: #3D2B1F;
  letter-spacing: 0.05em;
  margin: 0 0 ${({ theme }) => theme.spacing.lg};
`;

export const DescriptionText = styled.p`
  font-size: ${({ theme }) => theme.typography.fontSize.lg};
  color: ${({ theme }) => theme.colors.text.primary};
  line-height: 1.8;
  margin: 0 0 ${({ theme }) => theme.spacing.xl};
`;

export const Divider = styled.p`
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  color: #C4956A;
  letter-spacing: 0.15em;
  margin: 0 0 ${({ theme }) => theme.spacing.md};
`;

export const DetailText = styled.p`
  font-size: ${({ theme }) => theme.typography.fontSize.lg};
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 1.8;
  margin: 0;
`;

export const ActionButtonArea = styled.div`
  padding: ${({ theme }) => theme.spacing.lg} ${({ theme }) => theme.spacing.xl} ${({ theme }) => theme.spacing.xl};
  margin-top: auto;
`;

export const ActionButton = styled.button`
  width: 100%;
  min-height: 56px;
  background-color: #C4956A;
  color: #FFFFFF;
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  font-size: ${({ theme }) => theme.typography.fontSize.lg};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.md};
  transition: opacity 0.2s ease;

  &:active {
    opacity: 0.8;
    transform: scale(0.98);
  }
`;
